module.exports = "../images/family-package@2x.jpg?v=2bb7c58";